module.exports = __webpack_public_path__ + "static/media/cv.9f4e0ed2.pdf";